export default __webpack_public_path__ + "static/media/segre15.5bd62788.jpg";